import React, { memo, useEffect, useState } from 'react';
import StarterPackOffer from './monetization/StarterPackOffer';
import RewardedAdPrompt from './monetization/RewardedAdPrompt';

function GameOver({
  score, highScore, linesCleared, moveCount, onNewGame, onBackToMenu, isDaily,
  sessionNumber, onShowSubscription, onPurchaseStarterPack, onWatchAd,
  showStarterPackOffer, showRewardedOffer, rewardedPowerUpType,
  dailyNumber, dailyStreak, onShare,
}) {
  const [visible, setVisible] = useState(false);
  const [offerDismissed, setOfferDismissed] = useState(false);
  const isNewHighScore = score >= highScore && score > 0;

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const showConversion = !offerDismissed && sessionNumber >= 4;

  return (
    <div className={`game-over-overlay${visible ? ' game-over-visible' : ''}`} role="dialog" aria-label="Game Over">
      <div className="game-over-card">
        <h2 className="game-over-title">{isDaily && dailyNumber ? `DAILY #${dailyNumber}` : 'GAME OVER'}</h2>

        {isNewHighScore && (
          <div className="new-high-score">NEW HIGH SCORE!</div>
        )}

        {isDaily && dailyStreak >= 2 && (
          <div className="daily-streak-badge">&#128293; {dailyStreak}-day streak</div>
        )}

        <div className="game-over-score">{score.toLocaleString()}</div>

        <div className="game-over-stats">
          <div className="stat">
            <span className="stat-value">{linesCleared}</span>
            <span className="stat-label">Lines</span>
          </div>
          <div className="stat">
            <span className="stat-value">{moveCount}</span>
            <span className="stat-label">Moves</span>
          </div>
          <div className="stat">
            <span className="stat-value">{highScore.toLocaleString()}</span>
            <span className="stat-label">Best</span>
          </div>
        </div>

        {/* Conversion Zone */}
        {showConversion && (
          <div className="game-over-conversion">
            {showRewardedOffer && sessionNumber >= 4 && sessionNumber <= 7 && (
              <RewardedAdPrompt
                powerUpType={rewardedPowerUpType || 'bomb'}
                onWatchAd={onWatchAd}
                onDismiss={() => setOfferDismissed(true)}
              />
            )}

            {showStarterPackOffer && sessionNumber >= 8 && (
              <StarterPackOffer
                onPurchase={onPurchaseStarterPack}
                onDismiss={() => setOfferDismissed(true)}
              />
            )}

            {!showStarterPackOffer && !showRewardedOffer && sessionNumber >= 8 && onShowSubscription && (
              <button className="game-over-premium-cta" onClick={onShowSubscription}>
                &#9733; Go Premium — No Ads + Daily Power-ups
              </button>
            )}
          </div>
        )}

        {isDaily && onShare && (
          <button className="share-result-btn" onClick={onShare}>
            SHARE RESULT
          </button>
        )}

        <button className="play-again-btn" onClick={onNewGame} autoFocus>
          {isDaily ? 'TRY AGAIN' : 'PLAY AGAIN'}
        </button>

        {onBackToMenu && (
          <button className="menu-return-btn" onClick={onBackToMenu}>
            BACK TO MENU
          </button>
        )}
      </div>
    </div>
  );
}

export default memo(GameOver);
